// src/services/categoryService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'categories/';
const SUCURSALES_URL = 'sucursales/';
const ACTIVIDADES_URL = 'facturacion/actividades-economicas/';

// --- NUEVO: Obtener lista de sucursales para el select ---
export const fetchSucursalesList = async () => {
    return handleRequestWithAuth(async () => {
        // Asumimos que devuelve una lista de objetos { id, nombre, ... }
        const response = await axiosInstance.get(SUCURSALES_URL); 
        return response.data;
    });
};

export const fetchActividadesEconomicas = async () => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(ACTIVIDADES_URL, { params: { activa: true } });
        return Array.isArray(response.data) ? response.data : (response.data.results || []);
    });
};

export const fetchCategories = async () => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    });
};

export const createCategory = async (data: {
    nombre: string;
    descripcion?: string;
    imagen?: File | null;
    estado: boolean;
    sucursales: number[];
    actividad_economica?: number | null;
}) => {
    return handleRequestWithAuth(async () => {
        const formData = new FormData();
        formData.append('nombre', data.nombre);
        if (data.descripcion) formData.append('descripcion', data.descripcion);
        if (data.imagen) formData.append('imagen', data.imagen);
        formData.append('estado', data.estado.toString());
        if (data.actividad_economica !== undefined) formData.append('actividad_economica', data.actividad_economica === null ? '' : String(data.actividad_economica));

        // Manejo de ManyToMany en FormData: se añade el mismo key múltiples veces
        data.sucursales.forEach((id) => {
            formData.append('sucursales', id.toString());
        });

        const response = await axiosInstance.post(API_URL, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    });
};

export const updateCategory = async (
    id: number,
    data: {
        nombre: string;
        descripcion?: string;
        imagen?: File | null;
        estado: boolean;
        sucursales: number[];
    actividad_economica?: number | null;
    }
) => {
    return handleRequestWithAuth(async () => {
        const formData = new FormData();
        formData.append('nombre', data.nombre);
        if (data.descripcion) formData.append('descripcion', data.descripcion);
        if (data.imagen) formData.append('imagen', data.imagen);
        formData.append('estado', data.estado.toString());
        if (data.actividad_economica !== undefined) formData.append('actividad_economica', data.actividad_economica === null ? '' : String(data.actividad_economica));

        // Manejo de ManyToMany
        data.sucursales.forEach((id) => {
            formData.append('sucursales', id.toString());
        });

        const response = await axiosInstance.put(`${API_URL}${id}/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    });
};

export const deleteCategory = async (id: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.delete(`${API_URL}${id}/`);
        return response.data;
    });
};


